import { useCallback, useEffect, useState } from "react";
import api, { errMsg } from "../lib/api";
import { fmtDate } from "../lib/constants";
import { Bell, Check, X } from "lucide-react";
import { toast } from "sonner";

export const ReminderList = ({ leadId, refreshKey }) => {
  const [items, setItems] = useState([]);
  const load = useCallback(() => api.get(`/leads/${leadId}/reminders`).then((r) => setItems(r.data)), [leadId]);
  useEffect(() => { load().catch(() => {}); }, [load, refreshKey]);
  const change = async (task, cancel) => {
    try { if (cancel) await api.delete(`/tasks/${task.id}`); else await api.put(`/tasks/${task.id}`, { completed: true }); await load(); }
    catch (e) { toast.error(errMsg(e)); }
  };
  return <section className="space-y-3 min-w-0" data-testid="lead-reminders">
    <h3 className="font-semibold text-sm flex items-center gap-2" data-testid="lead-reminders-title"><Bell size={16} /> Reminders</h3>
    <p className="text-xs text-muted-foreground" data-testid="lead-reminders-timezone">Australia/Melbourne · 10 minutes before & at the scheduled time</p>
    {!items.length && <p className="text-sm text-muted-foreground" data-testid="lead-reminders-empty">No scheduled reminders</p>}
    {items.map((task) => <div key={task.id} className="border-b border-border py-3 min-w-0" data-testid={`reminder-${task.id}`}>
      <p className="text-sm font-medium break-words" data-testid={`reminder-title-${task.id}`}>{task.title}</p>
      <p className="text-xs text-muted-foreground mt-1" data-testid={`reminder-time-${task.id}`}>{fmtDate(task.due_at)} · Melbourne</p>
      <p className="text-xs text-muted-foreground" data-testid={`reminder-owner-${task.id}`}>{task.user_name}</p>
      <div className="flex gap-3 mt-2"><button type="button" onClick={() => change(task, false)} data-testid={`reminder-complete-${task.id}`} className="text-primary text-xs inline-flex gap-1 items-center"><Check size={13} /> Complete</button>
        <button type="button" onClick={() => change(task, true)} data-testid={`reminder-cancel-${task.id}`} className="text-destructive text-xs inline-flex gap-1 items-center"><X size={13} /> Cancel</button></div>
    </div>)}
  </section>;
};